import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/main.less";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import PageSpinner from "./components/PageSpinner/PageSpinner";
import store from "./store/app";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback={<PageSpinner />}>
      <Provider store={store}>
        <ConfigProvider theme={{ hashed: false }}>
          <App />
        </ConfigProvider>
      </Provider>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
